<template>
  <div class="progress-container" style="position: relative;">
    <span class="percentage-style">
    {{ percentage }}%
    </span>
    <svg :width="size" :height="size" viewBox="-12 12 50 50">
      <path
        class="circle"
        d="M14 0
          a 12 12 0 0 1 0 24
          a 12 12 0 0 1 0 -24"
        fill="none"
        :stroke="bgColor"
        :stroke-width="strokeWidth"
      ></path>
      <path
        class="circle"
        d="M14 0
          a 12 12 0 0 1 0 24
          a 12 12 0 0 1 0 -24"
        fill="none"
        :stroke="color"
        :stroke-width="strokeWidth"
        stroke-linecap="butt"
        :style="circleStyle"
      ></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'CircularProgressBar',
  props: {
    percentage: {
      type: Number,
      required: true,
    },
    strokeWidth: {
      type: Number,
      default: 8,
    },
    size: {
      type: Number,
      default: 100,
    },
    color: {
      type: String,
      default: '#3498db',
    },
    bgColor: {
      type: String,
      default: '#ddd',
    },
  },
  computed: {
    circleStyle() {
        const actualCircumference = 2 * Math.PI * 12;
        const dashArray = actualCircumference;
        const offset = ((100 - this.percentage) / 100) * actualCircumference;

        return {
          strokeDasharray: dashArray.toString(),
          strokeDashoffset: offset.toString(),
        };
      },
    },
};
</script>

<style scoped>
.circular-chart {
  max-width: 100%;
  height: auto;
  display: block;
}

.circle {
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}

.progress-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.percentage-style {
  position: absolute;
  top: 46%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  font-size: 1.1em;
  font-weight: bold;
  color: #000;
  text-shadow: 
    -1.5px -1.5px 2px #fff,  
     1.5px -1.5px 2px #fff,
    -1.5px  1.5px 2px #fff,
     1.5px  1.5px 2px #777;
  -webkit-text-stroke: 0.5px #fff;
}
</style>
